<template>
    <div id="app">
        <homeHead></homeHead>
        <homeNav></homeNav>
        <homeMain  :donationList="donationList" :tempList4="recommendData" :tempList1="recommendData[1]" :tempList2="recommendData[2]" ></homeMain>
        <homeProject   :recommendData="recommendData" ></homeProject>
        <homeInfo v-if="$store.state.webInfo.style!='yueyang'"  :tempList3="recommendData[3]" :tempList4="recommendData" :donationList="donationList" ></homeInfo>
        <homeFooter></homeFooter>
    </div>
</template>
<script>
// 首页
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import homeMain from './main.vue'
import homeProject from './project.vue'
import homeInfo from './info.vue'
import homeFooter from '@/components/Public/footer.vue'
    export default {
        components:{
            homeHead,
            homeNav,
            homeMain,
            homeProject,
            homeInfo,
            homeFooter
        },
        metaInfo(){
            return {
                title: this.$store.state.webInfo.title+"-首页",
                meta:[{
                     name: this.$store.state.webInfo.key_words,
                     content: this.$store.state.webInfo.describe
                 }],
                 link: [{                
                    rel: 'asstes',
                    href: this.$url.webUrl
                }]
            } 
        },
        data(){
            return {
                recommendData:[],
                // tempList1:{},
                // tempList2:{},
                // tempList3:{},
                // tempList4:[],
                donationList:[],
            }
        },
        methods:{
        },
        created(){
           
            this.$db.get(this.$url.indexConfig.list).then(res=>{
                
               let new_data = []
               res.data.forEach((item,index) => {
                item.value.limit = Number(item.value.limit)
                item.value.channel_id = Number(item.value.channel_id)
                new_data[item.index]=item
               });
           
               this.$set(this,'recommendData',new_data)
           
           }).then(()=>{
               this.$db.get(this.$url.donation.list+'?page_size=100').then(res=>{
                   this.donationList = res.data.data
               }).catch(err => {
                    console.log(err);
                });
           }).catch(err => {
                console.log(err);
            });
        }
    }
</script>
<style lang="less" scoped>
@import '../Public/common.less';
    #app {
        -webkit-overflow-scrolling: touch;
    }
    .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home/index.vue